import { Tag } from "antd";
import { useAppSelector } from "Store/hooks";
import { selectProductEditions } from "../../redux/selectors";
import { SubscriptionProductEdition } from "Features/SubscriptionConfiguration/SubscriptionTiers/redux/types";

export const ProductEditionRenderer = ({
  value,
}: {
  value: SubscriptionProductEdition | string;
}) => {
  const productEditions = useAppSelector(selectProductEditions);
  const productEdition = productEditions?.find(
    (edition) => edition.name?.toString() === value?.toString()
  );

  const getColor = (value: SubscriptionProductEdition | string) => {
    const enumValue =
      typeof value === "string"
        ? (SubscriptionProductEdition as any)[value]
        : value;

    switch (enumValue) {
      case SubscriptionProductEdition.CenterpriseReportMiner:
        return "blue";
      case SubscriptionProductEdition.CenterpriseEdi:
        return "green";
      case SubscriptionProductEdition.CenterpriseAnalytics:
        return "yellow";
      case SubscriptionProductEdition.CenterpriseDataIntegrator:
        return "purple";
      case SubscriptionProductEdition.CenterpriseDataWarehousing:
        return "cyan";
      case SubscriptionProductEdition.CenterpriseDataServices:
        return "red";
      case SubscriptionProductEdition.ReadOnly:
        return "blue";
      case SubscriptionProductEdition.ReportMinerPersonal:
        return "green";
      case SubscriptionProductEdition.CenterpriseStudentEdition:
        return "yellow";
      case SubscriptionProductEdition.CenterpriseTrialEdition:
        return "purple";
      case SubscriptionProductEdition.CenterpriseBaseEdition:
        return "orange";
      case SubscriptionProductEdition.DPBDataPrep:
        return "red";
      case SubscriptionProductEdition.DataPrepPersonal:
        return "purple";
      case SubscriptionProductEdition.Docspire:
        return "purple";
      default:
        return "gray";
    }
  };

  if (!productEdition) {
    return <span>N/A</span>;
  }

  return <Tag color={getColor(value)}>{productEdition?.description}</Tag>;
};
